<!-- @if (isLogin()) {
    <router-outlet></router-outlet>
} @else {    
    <app-main-layout></app-main-layout>
} -->

@if (isPublicRoute() && mobileDashboard.isIOS && mobileDashboard.standalone) {
    <div class="mobile-dashboard-switcher">
        <button nz-button nzType="link" (click)="mobileDashboard.error = ''; mobileDashboard.showOpenLink = true">Open another breakdown</button>
    </div>
}
<nz-modal [(nzVisible)]="mobileDashboard.showOpenLink" nzTitle="Open another breakdown"
    [nzFooter]="openBreakdownFooter" (nzOnCancel)="mobileDashboard.showOpenLink = false" [nzWidth]="420">
    <ng-container *nzModalContent>
        <p>Copy the breakdown link from WhatsApp and paste it here. This app will open it and register chat notifications when chat is available.</p>
        <label for="mobile-breakdown-link">Breakdown link</label>
        <input id="mobile-breakdown-link" nz-input type="url" [(ngModel)]="mobileDashboard.link"
            placeholder="Paste your breakdown link" (keyup.enter)="mobileDashboard.openLink()" />
        @if (mobileDashboard.error) { <p role="alert">{{ mobileDashboard.error }}</p> }
    </ng-container>
    <ng-template #openBreakdownFooter>
        <button nz-button (click)="mobileDashboard.showOpenLink = false">Cancel</button>
        <button nz-button nzType="primary" (click)="mobileDashboard.openLink()">Open breakdown</button>
    </ng-template>
</nz-modal>
 @if (isLogin() || isPublicRoute()) {
    <router-outlet></router-outlet>
} @else {
    <app-main-layout> </app-main-layout>
    <app-location-update></app-location-update>
}

<nz-modal
    [(nzVisible)]="isCallcentreOperatorModalVisible"
    nzTitle="Who are you?"
    [nzFooter]="null"
    (nzOnCancel)="dismissCallcentreOperatorModal()"
    nzWidth="420px">
    <ng-container *nzModalContent>
        <p class="callcentre-operator-modal__prompt">
            Select the call centre operator using this phone.
        </p>

        @if (availableCallcentreOperators.length > 0) {
            <div class="callcentre-operator-modal__options">
                @for (operator of availableCallcentreOperators; track operator.userId) {
                    <button
                        nz-button
                        nzBlock
                        [nzType]="selectedCallcentreOperatorId === operator.userId ? 'primary' : 'default'"
                        (click)="selectCallcentreOperator(operator.userId)">
                        {{ operator.firstName }} {{ operator.lastName }}
                    </button>
                }
            </div>
        } @else {
            <p class="callcentre-operator-modal__empty">
                No call centre operators are available for this client.
            </p>
        }
    </ng-container>

</nz-modal>
